import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  ControllerModal,
  DialogContent,
  Typography,
} from '@bymason-private/legacy-pattern-components';
import { formatMinutesSeconds } from '../utils';

let timeoutCountdown = 0;

interface TimeoutWarningModalProps {
  open: boolean;
  timeoutRemainingSec: number;
  onClose: (timeToAddBack: number, proceed?: boolean) => void;
}

export function TimeoutWarningModal({ onClose, open, timeoutRemainingSec }: TimeoutWarningModalProps) {
  const [countdown, setCountdown] = useState(0);

  const handleContinue = () => {
    onClose(timeoutRemainingSec - timeoutCountdown, true);
  };

  const handleEnd = () => {
    onClose(timeoutRemainingSec - timeoutCountdown);
  };

  const minutesRemaining = formatMinutesSeconds(countdown);

  useEffect(() => {
    let intervalId = 0;

    if (timeoutRemainingSec) {
      timeoutCountdown = timeoutRemainingSec;
      setCountdown(timeoutCountdown);

      intervalId = window.setInterval(() => {
        timeoutCountdown--;
        setCountdown(timeoutCountdown);

        if (timeoutCountdown === 0) {
          onClose(timeoutRemainingSec - timeoutCountdown, false);
        }
      }, 1000);
    }

    return () => {
      window.clearInterval(intervalId);
    };
  }, [onClose, timeoutRemainingSec]);

  return (
    <ControllerModal
      onClose={handleContinue}
      open={open}
      subTitle={
        <>
          <Typography component='div'>
            Your session is about to timeout and will automatically end in:
          </Typography>
          <Typography
            className='MasonTextPrimary'
            component='div'
            sx={{
              fontSize: 26,
              lineHeight: `${30 / 16}rem`,
              margin: [1, 0, 2, 0],
            }}
            // variant={ControllerFontType.Decor400R}
          >
            {minutesRemaining}
          </Typography>
          <Typography component='div'>
            To continue your session, select <strong>Continue session</strong>
          </Typography>
        </>
      }
      title='Timeout warning'
    >
      <DialogContent sx={{ maxWidth: '30vw', minWidth: 480 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            gap: 2,
            marginTop: 7,
          }}
        >
          <Button color='secondary' onClick={handleEnd} size='medium' variant='text'>
            End session
          </Button>
          <Button color='primary' onClick={handleContinue} size='medium' variant='contained'>
            Continue session
          </Button>
        </Box>
      </DialogContent>
    </ControllerModal>
  );
}
